import favicon from '@/assets/icons/favicon.ico';

export function insertFavicon() {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = favicon;
    document.head.appendChild(link);
}

export function safeString(str = '') {
    return (str || '').replace(/@.*/, '').replace(/[^a-zA-Z\d]/g, '_');
}

export function createDefaultId(length) {
    const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return `${result}_${new Date().getTime()}`;
}

let user = {};
export const getEventUser = () => user;

export function parseJwt(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );
    return JSON.parse(jsonPayload);
}

export function createDebounce(method, delay) {
    let timeoutId = 0;

    function debounce(fn, delay) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn(), delay);
    }

    return (...args) => debounce(() => method(...args), delay);
}

export function addSetPrefix(value) {
    const prefix = value.split('-')[0];
    return `${prefix} ${value}`;
}
